export const menu = () => {
    const section = document.querySelector('.section-menu');
    if (!section) return;

    const hamburger = section.querySelector('.nav__hamburger');
    const menuWrap = section.querySelector('.content-menu');

    hamburger.addEventListener('click', () => {
        const isOpen = menuWrap.classList.toggle('is-open');
        hamburger.classList.toggle('is-active', isOpen);
        hamburger.setAttribute('aria-expanded', isOpen);
        hamburger.setAttribute('aria-label', isOpen ? 'Close Menu' : 'Open menu');
    });

  /*  // Submenús (acordeón hacia abajo)
    section.querySelectorAll('.submenu-toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const li = toggle.closest('.menu-item');
            const subMenu = li.querySelector(':scope > .sub-menu');
            if (!subMenu) return;

            const isOpen = subMenu.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', isOpen);
        });
    });*/
}
